// Script para vincular sales points con tabs de product-full-width
document.addEventListener('DOMContentLoaded', function() {
  // Buscar todos los botones con clase tab-trigger
  const tabTriggers = document.querySelectorAll('.tab-trigger');
  
  tabTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const tabTarget = this.getAttribute('data-tab-target');
      
      if (tabTarget) {
        // Buscar por ID personalizado exacto
        let targetTab = document.querySelector(`[data-tab-id="${tabTarget}"]`);
        
        if (targetTab) {
          activateTab(targetTab);
          return;
        }
        
        // Fallback: buscar por handle del título
        const targetHandle = tabTarget.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
        targetTab = document.querySelector(`[data-tab-id="${targetHandle}"]`);
        
        if (targetTab) {
          activateTab(targetTab);
          return;
        }
        
        // Último fallback: buscar por contenido del título
        const allTabs = document.querySelectorAll('.product-full-width .product-block--tab');
        
        for (let tab of allTabs) {
          const tabButton = tab.querySelector('.collapsible-trigger');
          if (tabButton) {
            const tabText = tabButton.textContent.toLowerCase().trim();
            const targetText = tabTarget.toLowerCase().replace(/-/g, ' ');
            
            if (tabText.includes(targetText) || targetText.includes(tabText)) {
              activateTab(tab);
              return;
            }
          }
        }
        
        // Si no encuentra ninguna tab específica, hacer scroll a la sección
        const productFullWidth = document.querySelector('.product-full-width');
        if (productFullWidth) {
          productFullWidth.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  function activateTab(tabElement) {
    // Scroll hacia la sección de tabs
    const productFullWidth = document.querySelector('.product-full-width');
    if (productFullWidth) {
      productFullWidth.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      
      // Esperar un momento para que termine el scroll y luego activar la tab
      setTimeout(() => {
        const tabButton = tabElement.querySelector('.collapsible-trigger');
        
        if (tabButton) {
          // Verificar si la tab ya está abierta
          const isExpanded = tabButton.getAttribute('aria-expanded') === 'true';
          
          if (!isExpanded) {
            // Simular click en el botón del collapsible
            tabButton.click();
          }
        }
      }, 800);
    }
  }
});
